export default __webpack_public_path__ + "static/media/icon-002.58b06756.svg";